import React from 'react';
import { render } from 'react-dom';
import { isMobile } from "react-device-detect";

export const ConfirmAlert = (label, onYes, onNo, options = { title: 'Confirmation', yesLabel: 'Yes', noLabel: 'No' }) => {
  const rootElement = document.getElementById('my-confirm-modal');

  if (!rootElement) {
    console.error('Alert Marker not found!'); // eslint-disable-line no-console
    return;
  }

  const handleYes = () => {
    onYes();
    render(<div id="my-confirm-modal" />, rootElement);
  };

  const handleNo = () => {
    if (onNo) onNo();
    render(<div id="my-confirm-modal" />, rootElement);
  };

  render(
    <div>
      <div className="modal-open" style={{ position: 'absolute', zIndex: 7778 }}>
        <div>
          <div className="modal fade in show" style={{ display: 'block', zIndex: 7779 }}>
            <div className={`modal-dialog ${isMobile ? 'modal-custom-div' : ''}`}>
              <div className="modal-content">
                <div className="modal-header cms-bg-color-primary">
                  <h4 className="modal-title">{options?.title ?? 'Confirmation'}</h4>
                </div>
                <div className="modal-body">
                  <label>{label}</label>
                </div>
                <div className="modal-footer text-right">
                  <button
                    type="button"
                    className="btn btn-primary cms-bg-color-primary"
                    onClick={handleYes}
                  >
                    {options.yesLabel}
                  </button>
                  &nbsp;
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleNo}
                  >
                    {options.noLabel}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal-backdrop fade in show"
            style={{ zIndex: 7778 }}
            // onClick={handleN/o}
          />
        </div>
      </div>
    </div>,
    rootElement,
  );
};

const Marker = () => (
  <div id="my-confirm-modal" />
);

export default Marker;
